import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><g id="$" fill="#000"><path d="M16 32a16 16 0 110-32 16 16 0 010 32zm0-2a14 14 0 100-28 14 14 0 000 28z" fillRule="nonzero" opacity=".1" /><path d="M16 2V0A16 16 0 000 16h2A14 14 0 0116 2z" /></g></g></svg>);